import React from "react";
import {
  DateTimePicker as MaterialDateTimePicker,
  DatePicker as MaterialDatePicker,
} from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";

export class DateTimePicker extends React.Component {
  handleChange(newValue) {
    const {
      onChange,
      field: { name },
    } = this.props;
    if (!newValue) {
      onChange(name, newValue);
    } else {
      onChange(name, newValue.format());
    }
  }

  handleBlur() {
    const { onBlur, name } = this.props;
    onBlur(name, true);
  }

  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  render() {
    const { variant } = this.props;
    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <MaterialDateTimePicker
          {...this.props}
          inputVariant={variant}
          value={this.props.field.value}
          onChange={this.handleChange}
          format="DD/MM/YYYY HH:mm"
          invalidLabel="DD/MM/YYYY HH:mm"
          ampm={false}
          clearable
        />
      </MuiPickersUtilsProvider>
    );
  }
}

export class DatePicker extends React.Component {
  handleChange(newValue) {
    const {
      onChange,
      field: { name },
    } = this.props;
    if (!newValue) {
      onChange(name, newValue);
    } else {
      onChange(name, newValue.format("YYYY-MM-DD"));
    }
  }

  handleBlur() {
    const { onBlur, name } = this.props;
    onBlur(name, true);
  }

  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  render() {
    const { variant } = this.props;
    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <MaterialDatePicker
          {...this.props}
          inputVariant={variant}
          value={this.props.field.value}
          onChange={this.handleChange}
          format="DD/MM/YYYY"
          invalidLabel="DD/MM/YYYY"
          clearable
        />
      </MuiPickersUtilsProvider>
    );
  }
}
